import { createElement } from 'react';

/**
 * A text file's text in the preview (src/textPreview.ts reads it). Drawn as React text inside a <pre>, never as HTML,
 * so markup in a file shows as the characters it is. Written with createElement, not JSX, so
 * web/test/text-preview.test.ts can render it under node.
 */
export function TextPreview({ text, cut, bytes }: { text: string; cut: boolean; bytes: number }) {
  return createElement('div', { className: 'w-full self-stretch space-y-2' },
    cut ? createElement('p', { role: 'status', className: 'text-sm text-neutral-800' },
      `This file is ${(bytes / 1024 / 1024).toFixed(1)} MB: only its first 1 MB is shown. Download it to read the rest.`) : null,
    createElement('pre', {
      className: 'max-h-[80dvh] overflow-auto whitespace-pre-wrap break-words rounded bg-white p-3 font-mono text-sm text-neutral-900',
    }, text));
}
